import React, { useState } from 'react';
import { Text, Flex, Stack, FormLabel } from '@chakra-ui/react';
import { Select } from '../Input';
import { PillarSelect } from '../Catalog/CatalogSelect';
import { levelOptions, numberOfThemesOptions } from '../../resources/mock_options';

// EG-40: este componente é compartilhado pela criação de diagnóstico e de
// periódico. Era aqui que o nome do pilar era digitado — e por isso os dois
// fluxos produziam um conceito novo a cada questionário.
//
// Agora o pilar vem do catálogo global. Digitar livremente era justamente o que
// permitia "Governança" e "Governança empresarial" nascerem como coisas
// distintas: nenhuma deduplicação por nome resolve esse caso, porque as
// strings diferem de fato. O seletor mostra o que já existe antes de o gestor
// inventar um nome novo.
export default function PillarConfigRow({
 index,
 control,
 field,
 register,
 setValue,
 showNumberOfThemes,
 showNumberOfLevels,
}) {
 const [idPillar, setIdPillar] = useState(field?.idPillar ?? null);

 if (field?.invisible) return null;

 return (
  <Flex gap='6' align='start'>
   <Text color='#5C6066' fontWeight={600} whiteSpace='nowrap' mt='38px'>
    Pilar {index + 1}
   </Text>

   <Stack minW='320px'>
    <FormLabel fontSize='sm' mb='0'>
     Pilar
    </FormLabel>
    <PillarSelect
     id={`form-${index}-id_pillar`}
     value={idPillar}
     onChange={(escolhido) => {
      setIdPillar(escolhido);
      setValue?.(`form.${index}.idPillar`, escolhido);
     }}
    />
   </Stack>

   {showNumberOfThemes && (
    <Select
     {...register(`form.${index}.numberOfThemes`)}
     label='Número de temas'
     placeholder='Selecione o número de temas do pilar'
     options={numberOfThemesOptions}
    />
   )}

   {showNumberOfLevels && (
    <Select
     {...register(`form.${index}.numberOfLevels`)}
     label='Número de níveis'
     placeholder='Selecione o número de níveis por tema'
     options={levelOptions}
    />
   )}
  </Flex>
 );
}
